import * as React from "react";

const SvgIcnQueues = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="currentColor" strokeWidth={1} fill="none" fillRule="evenodd">
            <rect x={3.5} y={4.5} width={17} height={14} rx={1} />
            <path d="M6.5 20.5h11M12.5 13.5h5M12.5 7.5h5M12.5 15.5H16M12.5 9.5H16" strokeLinecap="round" />
            <circle cx={8.5} cy={8.5} r={2} />
            <circle cx={8.5} cy={14.5} r={2} />
        </g>
    </svg>
);

export default SvgIcnQueues;
